import { apiClient } from '@/api/client'
import type { TranscribeResponse } from '@/api/type'

export const getTranscription = async (episodeId: string): Promise<TranscribeResponse> => {
  const res = await apiClient.get(`/products/${episodeId}/transcribe`)
  return res.data
}

export const saveTranscription = async (
  episodeId: string,
  transcription: TranscribeResponse,
): Promise<TranscribeResponse> => {
  const res = await apiClient.put(`/products/${episodeId}/transcribe`, transcription)
  return res.data
}
